export const issueListEult = [
  {
    titleKey: 'poorResults.eult.title.sanitizerIssue',
    detailsKey: 'poorResults.eult.details.sanitizerIssue',
    keyValue: 1,
    answered: false,
    status: '',
    expanded: false,
    images: [],
    video: '',
  },
  {
    titleKey: 'poorResults.eult.title.waterTempIssue',
    detailsKey: 'poorResults.eult.details.waterTempIssue',
    keyValue: 2,
    answered: false,
    status: '',
    expanded: false,
    images: [],
    video: '',
  },
  {
    titleKey: 'poorResults.eult.title.waterOn',
    detailsKey: '',
    keyValue: 3,
    answered: false,
    status: '',
    expanded: false,
    images: [],
    video: '',
  },
  {
    titleKey: 'poorResults.eult.title.endCap',
    detailsKey: 'poorResults.eult.details.endCap',
    keyValue: 4,
    answered: false,
    status: '',
    expanded: false,
    images: [
      'assets/images/troubleshooting/eult/eult-spray-arm-end-cap-1.png',
      'assets/images/troubleshooting/eult/eult-spray-arm-end-cap-2.png',
    ],
    video: '',
    isImagePopup: true,
  },
  {
    titleKey: 'poorResults.eult.title.armSpinFreeze',
    detailsKey: 'poorResults.eult.details.armSpinFreeze',
    keyValue: 5,
    answered: false,
    status: '',
    expanded: false,
    images: ['assets/images/troubleshooting/eult/eult-arm-spin.gif'],
    video: '',
    isImagePopup: false,
  },
  {
    titleKey: 'poorResults.eult.title.noDebrisArm',
    detailsKey: 'poorResults.eult.details.noDebrisArm',
    keyValue: 6,
    answered: false,
    status: '',
    expanded: false,
    images: [
      'assets/images/troubleshooting/eult/eult-leaking-1.png',
      'assets/images/troubleshooting/eult/eult-leaking-2.png',
    ],
    video: '',
    isImagePopup: false,
  },
  {
    titleKey: 'poorResults.eult.title.primeChemist',
    detailsKey: '',
    keyValue: 7,
    answered: false,
    status: '',
    expanded: false,
    images: [
      'assets/images/troubleshooting/eult/eult-chemistry.jpg',
      'assets/images/troubleshooting/eult/prime-chemist.gif',
    ],
    video: '',
    isImagePopup: false,
  },
  {
    titleKey: 'poorResults.eult.title.noLimeScale',
    detailsKey: 'poorResults.eult.details.noLimeScale',
    keyValue: 8,
    answered: false,
    status: '',
    expanded: false,
    images: [
      'assets/images/poorresults/lime-scale.png',
      'assets/images/poorresults/lime-scale-dirt.png',
    ],
    video: '',
    isImagePopup: true,
  },
  {
    titleKey: 'poorResults.eult.title.softener',
    detailsKey: 'poorResults.eult.details.softener',
    keyValue: 9,
    answered: false,
    status: '',
    expanded: false,
    images: [],
    video: '',
  },
];
